import Socket from '../model/socket';

/**
 * Socket service
 * @type {{init: (function(*=, *=)), getSocketSvc: (function())}}
 */
export const SocketSvc = {
  /**
   * Initialize socket service
   * @param url
   * @param config
   */
  init(config) {
    this.socketSvc = new Socket(config);
  },

  /**
   * Get socket service
   * @returns {Socket | SocketSvc}
   */

  getSocketSvc() {
    return this.socketSvc;
  },
};



// WEBPACK FOOTER //
// socket.service.js